import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=094714cd"
import script from "./BaseAlert.vue?vue&type=script&lang=js"
export * from "./BaseAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports